<template>
    <FloatingPanel>
        <div class="canvas-blocks-custom-team-BlockPanel">

            <CommonInputs :options="options" />

        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
    },

};
</script>
